import { render, staticRenderFns } from "./PromoCodeHead.vue?vue&type=template&id=50970635&scoped=true"
import script from "./PromoCodeHead.vue?vue&type=script&lang=js"
export * from "./PromoCodeHead.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeHead.vue?vue&type=style&index=0&id=50970635&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50970635",
  null
  
)

export default component.exports